import React, { useEffect } from 'react'
import Calculator from '../../common/calculator'
import { Container } from '@mui/material'
import { useGeneralSetting } from '../../context/GeneralSettingContext'

const CalculatorPage = () => {
    const { generalSetting, loading } = useGeneralSetting();

    useEffect(() => {
        document.title = "EMI Calculator - " + generalSetting?.site_name || "Krishna finconcept";
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [])

    return (
        <Container maxWidth="lg" >
            <Calculator />
        </Container>
    )
}

export default CalculatorPage
